import { Component, Input, Output, EventEmitter, forwardRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';

@Component({
  selector: 'app-rating-stars',
  standalone: true,
  imports: [CommonModule],
  templateUrl:'./rating-stars.component.html',
  styleUrl:'./rating-stars.component.scss',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => RatingStarsComponent),
      multi: true
    }
  ]
})
export class RatingStarsComponent implements ControlValueAccessor {
  @Input() value: number = 0;
  @Input() showLabel: boolean = true;
  @Input() helpText: string = '';
  @Input() disabled: boolean = false;
  
  @Output() valueChange = new EventEmitter<number>();
  
  hoverValue: number | null = null;
  
  private onChange: (value: number) => void = () => {};
  private onTouched: () => void = () => {};

  setValue(star: number): void {
    if (this.disabled) return;
    
    this.value = star;
    this.onChange(star);
    this.onTouched();
    this.valueChange.emit(star);
  }

  getRatingLabel(rating: number): string {
    const labels: { [key: number]: string } = {
      1: 'Très insatisfait',
      2: 'Insatisfait',
      3: 'Neutre',
      4: 'Satisfait',
      5: 'Très satisfait'
    };
    return labels[rating] || 'Non évalué';
  }

  writeValue(value: number): void {
    this.value = value || 0;
  }

  registerOnChange(fn: (value: number) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }
}